import styled from "styled-components";
import { colors } from "../../../../../../consts";
import { Paragraph2 } from "../../../../../../components";

export const DeviceModelName = styled(Paragraph2)`
  font-weight: 700;
`;

export const DeviceTypeInfo = styled(Paragraph2)`
  font-size: 14px;
  line-height: 14px;
  font-weight: 500;
  color: ${colors.RAISIN_80};
`;
